module.exports = __webpack_public_path__ + "static/media/visual.d85648c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/visual.png
// module id = 580
// module chunks = 0